import { z } from 'zod';
import { captureHealth, isoDate, uuid } from './common';

/** A bot in somebody's meeting right now, and what this person may do to it. */
export const liveBot = z.object({
  runId: uuid,
  title: z.string(),
  health: captureHealth,
  startsAt: isoDate,
  canPause: z.boolean(),
  canResume: z.boolean(),
  canStop: z.boolean(),
});
export type LiveBot = z.infer<typeof liveBot>;

/**
 * What happened when somebody pressed **Send the notetaker** (PRD 42).
 *
 * `sending` is honest rather than optimistic: the api never calls Recall
 * itself (a request that waits on a third party is a request that can time out
 * halfway through spending money), so the answer at press time is that the job
 * is queued. The bot appears in `GET /bots/live` within seconds, and a failure
 * arrives as a notice the person can read.
 */
export const botSent = z.object({
  status: z.enum(['sending', 'already-there']),
  runId: uuid.nullable(),
});
export type BotSent = z.infer<typeof botSent>;
